<template lang="pug">
  .column.options
    router-link.option.row.middle.red(:to='{name: routes.preferencesLanguages}')
      simple-svg.m-right-1(:filepath='worldIcon' width='20px' height='20px')
      h2.title-small.bold {{ $t('preferences.options.languageConfiguration') }}
    button.option.row.middle.yellow(:class='{disabled: navigationTutorialActive}')
      simple-svg.m-right-1(:filepath='tutorialIcon' width='22px' height='22px')
      h2.title-small.bold(@click='showTutorialModal') {{ $t('preferences.options.tutorialActivation') }}
</template>

<script>
import worldIcon from '@/assets/ic_world.svg'
import tutorialIcon from '@/assets/ic_tutorial.svg'
import { routes } from '../../router'
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      routes,
      tutorialIcon,
      worldIcon
    }
  },
  computed: {
    ...mapState({
      navigationTutorialActive: state => state.userInfo.userInfo.navigationTutorialActive
    })
  },
  methods: {
    ...mapActions([
      'showElement'
    ]),
    showTutorialModal() {
      if (this.navigationTutorialActive) return
      this.showElement({ element: 'activateTutorialModal' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/_colors.scss';

.options{
  width: 500px;
  &>*:not(:last-child){
    margin-bottom: 20px;
  }
}
.option{
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  height: 66px;
  padding-left: 30px;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
  &::before{
    position: absolute;
    content: "";
    left: 0;
    width: 10px;
    height: 100%;
  }
  &.disabled{
    cursor: default;
    opacity: 0.5;
  }
  &.red{
    &::before{
      background-color: $red;
    }
  }
  &.yellow{
    &::before{
      background-color: $yellow;
    }
  }
}
</style>
